<section id="cta" data-home-cta class="contact-finale">
  <div class="contact-finale__marquee" aria-hidden="true">
    <span>XE ĐIỆN</span><i></i><span>MÁY NÔNG NGHIỆP</span><i></i><span>ĐIỆN GIA DỤNG</span>
  </div>

  <div class="contact-finale__body">
    <div class="contact-finale__copy">
      <span class="contact-finale__eyebrow">Bắt đầu từ nhu cầu của bạn</span>
      <h2>
        {{ content.heading }}
        <span>{{ content.highlightedHeading }}</span>
      </h2>
      <p>{{ content.description }}</p>

      <div class="contact-finale__actions">
        <a data-contact="phone" [href]="'tel:' + content.phone" class="contact-action contact-action--primary">
          <mat-icon svgIcon="hero:phone"></mat-icon>
          <span>
            <small>{{ content.phoneButtonLabel }}</small>
            <strong>{{ content.phone }}</strong>
          </span>
        </a>
        <a data-contact="email" [href]="'mailto:' + content.email" class="contact-action contact-action--secondary">
          <mat-icon svgIcon="hero:mail"></mat-icon>
          <span>
            <small>{{ content.emailButtonLabel }}</small>
            <strong>{{ content.email }}</strong>
          </span>
        </a>
      </div>
    </div>

    <aside class="contact-finale__details" aria-label="Thông tin liên hệ">
      <div data-contact-detail class="contact-detail contact-detail--hours">
        <mat-icon svgIcon="hero:schedule"></mat-icon>
        <div><small>{{ content.workingHoursLabel }}</small><strong>{{ content.workingHoursValue }}</strong></div>
      </div>
      <div data-contact-detail class="contact-detail contact-detail--address">
        <mat-icon svgIcon="hero:place"></mat-icon>
        <div><small>{{ content.addressLabel }}</small><strong>{{ content.addressValue }}</strong></div>
      </div>
      <div data-contact-detail class="contact-detail contact-detail--support">
        <mat-icon svgIcon="hero:headset_mic"></mat-icon>
        <div><small>{{ content.supportLabel }}</small><strong>{{ content.supportValue }}</strong></div>
      </div>
    </aside>
  </div>
</section>
